module.exports = require('./src/GithubCorner.vue')